import { AppEvent } from "./types";

export const defineAppEvent = (event: AppEvent): AppEvent => event;

